// Simplified formatters for application-types
export function prettyPhoneNumber(value: any): string {
  return value || '';
}

export function simplifyPhoneNumber(value: any): string {
  return value || '';
}
